import axios from "axios";

// ✅ Fetch Student Profile
export const fetchStudentProfile = async () => {
  try {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    if (!token || !userId) {
      console.error("❌ No Token or User ID Found!");
      return null;
    }

    console.log(`📢 Fetching student profile for user ID: ${userId}`);

    const response = await axios.get(`https://dynamic-reg-validation-service-51hl.onrender.com/api/register/user/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("✅ Student Profile Loaded:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error Fetching Student Profile:", error.response?.data || error.message);
    return null;
  }
};

// ✅ Update Student Profile
export const updateStudentProfile = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    if (!token || !userId) {
      console.error("❌ No Token or User ID Found!");
      throw new Error("Unauthorized");
    }

    console.log("📢 Sending request to update student profile...");

    const response = await axios.put(
      `https://dynamic-reg-validation-service-51hl.onrender.com/api/register/update/student/${userId}`, // ✅ Corrected URL
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    console.log("✅ Student Profile Updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error Updating Student Profile:", error.response?.data || error.message);
    throw error;
  }
};
